// src/screens/KioskAppointmentSuccessScreen.js
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import AppHeader from '../components/AppHeader';

const KioskAppointmentSuccessScreen = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const appointmentId = searchParams.get('appointmentId');
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    if (!user || user.role !== 'kiosk') {
      navigate('/login');
      return;
    }

    if (!appointmentId) {
      navigate('/kiosk');
      return;
    }
  }, [user, appointmentId, navigate]);

  // Countdown timer for auto-redirect
  useEffect(() => {
    if (countdown === 0) {
      navigate('/kiosk');
      return;
    }

    const timer = setTimeout(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown, navigate]);

  const handleNewAppointment = () => {
    navigate('/kiosk/book');
  };

  const handleHome = () => {
    navigate('/kiosk');
  };

  return (
    <div className="flex flex-col h-full">
      <AppHeader title="Appointment Confirmed" />

      <div className="flex-1 flex flex-col items-center justify-center p-6">
        <div className="text-center space-y-6 max-w-md">
          <div className="flex justify-center">
            <div className="w-16 h-16 rounded-full bg-green-500/20 flex items-center justify-center">
              <span className="text-4xl">✓</span>
            </div>
          </div>

          <div className="space-y-2">
            <h2 className="text-2xl font-bold text-app-text-light dark:text-app-text">
              Appointment Confirmed!
            </h2>
            <p className="text-app-text-secondary-light dark:text-app-text-secondary text-sm">
              The test drive has been successfully scheduled. The customer will receive a confirmation email.
            </p>
          </div>

          <div className="bg-app-bg-secondary-light dark:bg-app-bg-secondary rounded-2xl p-4 border border-app-border-light dark:border-app-border">
            <div className="text-xs text-app-text-secondary-light dark:text-app-text-secondary mb-1">Appointment ID</div>
            <div className="text-sm font-mono text-app-accent">
              {appointmentId}
            </div>
          </div>

          {/* Countdown message */}
          <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-3">
            <p className="text-blue-400 text-xs text-center">
              Returning to home in {countdown} second{countdown !== 1 ? 's' : ''}...
            </p>
          </div>

          <div className="space-y-3 pt-4">
            <button
              onClick={handleHome}
              className="w-full py-4 rounded-2xl bg-app-accent text-black text-base font-semibold hover:opacity-90 transition-opacity"
            >
              Done
            </button>

            <button
              onClick={handleNewAppointment}
              className="w-full py-4 rounded-2xl bg-app-bg-secondary-light dark:bg-app-bg-secondary text-app-text-light dark:text-app-text text-base font-semibold hover:opacity-90 transition-opacity"
            >
              Create Another Appointment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KioskAppointmentSuccessScreen;
